
/// <reference path="../../../app.d.ts"/>
import { User } from '../../../../../../shared/models/api/User/User';
import { BasicApplicationService } from '../../../../../../shared/services/BasicApplicationService';
import { ViewConfiguration } from '../../../../../../shared/services/BasicViewService';

import { AppPersistenceService } from '../../services/AppPersistenceService';
import { AppViewService } from '../../services/AppViewService';
import { AppValidationService } from '../../services/AppValidationService';
import { BasicErrorService } from '../../../../../../shared/services/BasicErrorService';
import { AppRouterService } from '../../services/AppRouterService';
import { AppApiService } from '../../services/AppApiService';
import { SuccessController } from './SuccessController';
import { CorrectionResponseApi } from '../../models/CorrectionResponseApi';
import { FeedbackType } from '../../models/FeedbackFormModel';
import { ApplicationPages } from '../../Constants';
import { AppUtils } from '../../../../../../shared/utils/index';

export abstract class DataCorrectionController implements StepController, StandardViewEvents {
	protected readonly $ctx: JQuery;
	protected readonly applicationRouter: AppRouterService;
	protected readonly appApiService: AppApiService;
	protected readonly applicationService: BasicApplicationService<FuelPricesUserFeedbackAppDefinition>;
	protected readonly appErrorService: BasicErrorService<FuelPricesUserFeedbackAppDefinition>;
	protected readonly user: User;
	protected readonly options: BasicAppOptions<FuelPricesUserFeedbackAppDefinition>;
	protected readonly appViewService: AppViewService;
	protected readonly appPersistenceService: AppPersistenceService;
	protected readonly parent: AppController;
	protected readonly loader: BasicLoader<FuelPricesUserFeedbackAppDefinition>;
	protected appValidationService?: AppValidationService;

	constructor(parent: AppController, options: BasicAppOptions<FuelPricesUserFeedbackAppDefinition>, loader: BasicLoader<FuelPricesUserFeedbackAppDefinition>, user: User) {
		this.parent = parent;
		this.options = options;
		this.loader = loader;
		this.user = user;
		this.$ctx = $(options.$ctx);

		this.applicationRouter = new AppRouterService(options);
		this.applicationService = new BasicApplicationService(options);
		this.appPersistenceService = new AppPersistenceService(options);
		this.appViewService = new AppViewService(parent, options, loader);
		this.appErrorService = new BasicErrorService(options);
		this.appApiService = new AppApiService(options);
	}

	public start(): void {
		if (this.checkPreconditions()) {
			const viewConfig: ViewConfiguration<FuelPricesUserFeedbackAppDefinition> = {
				data: this.getViewOptions(),
				templateurl: this.options.app.currenttemplate.templateurl,
				campaignurls: this.options.app.campaignurls,
				parent: this,
				$ctx: this.$ctx,
				options: this.options,
				callback: this.afterRenderApp
			};
			this.appViewService.render(viewConfig);
		} else {
			this.applicationRouter.error();
		}

	}

	protected checkPreconditions(): boolean {
		const formModel = this.appPersistenceService.getFormModelFromStore();
		return formModel.GasStation && formModel.GasStation.ID ? true : false; //NOSONAR S1125 is not applicable in strict mode
	}

	/**
	 * getViewOptions
	 *
	 * returns view options for the page.
	 * only variables defined in here are available in the view to use with handlebars.
	 */
	protected getViewOptions(): { [key: string]: any } {
		const formModel = this.appPersistenceService.getFormModelFromStore();
		return {
			Form: formModel,
			User: this.user,
			nexturl: this.options.app.nexturl || '',
			prevurl: this.applicationRouter.PriceDetailsUrl || this.options.app.prevurl || ''
		};
	}

	public afterRenderApp(): void {
		this.loader.loadSubApps({ options: this.options }, () => {
			this.appValidationService = new AppValidationService({ options: this.options }, this.appViewService.getForm());
			this.parent.afterRenderApp();

			this.appViewService.setFormModelToView();

			this.appViewService.addListeners(this);
			AppUtils.View.stopLoader();
			AppUtils.View.scrollTop();
		});
	}

	public viewChangeListener(): void {
		AppUtils.Helper.scheduleTask(() => {
			const formModel = this.appViewService.getFormModelFromView(this.getFeedbackType(), this.appPersistenceService.getFormModelFromStore());
			formModel.Modifed = true;
			this.appPersistenceService.setFormModelToStore(formModel);
		}, 'background');
	}

	public abstract submitListener(event: JQuery.Event): void;

	protected abstract getFeedbackType(): FeedbackType;

	/**
	 * If the sucess page is no real application page, simulate success step to treat it equal to other steps.
	 */
	protected renderSuccessTemplate(successResponse: CorrectionResponseApi): void {
		const successOptions = this.applicationService.preparePageOptions(ApplicationPages.Success);
		const successController = new SuccessController(this.parent, successOptions, this.user, this.loader, successResponse);
		successController.start();
	}
}